import React from 'react';
import PropTypes from 'prop-types';

const AliasesResultRow = ({ row }) => (
  <table className="ir-search-table-results sticky-enabled">
    <tbody>
      <tr>
        <td>
          <span className="address-name" dangerouslySetInnerHTML={{ __html: row.party.name }} /><br />
          {row.party.address &&
            <span style={{ whiteSpace: 'pre-wrap' }}>{row.party.address}</span>
          }
          {row.party.phone &&
            <div>t: {row.party.phone}</div>
          }
          {row.party.fax &&
            <div>f: {row.party.fax}</div>
          }
          {row.party.email &&
            <div>{row.party.email}</div>
          }
          {row.party.role &&
            <div><em>({row.party.role})</em></div>
          }
        </td>
        <td>
          {row.party_alias.length > 1 ? 'has aliases' : 'has alias'}
        </td>
        <td>
          {row.party_alias.map(alias => (
            <p>
              <span className="address-name" dangerouslySetInnerHTML={{ __html: alias.name }} />
              {alias.role &&
                <em><br />({alias.role})</em>
              }
            </p>
          ))}
        </td>
      </tr>
    </tbody>
  </table>
);

AliasesResultRow.propTypes = {
  row: PropTypes.any.isRequired,
};

export default AliasesResultRow;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/rows/AliasesResultRow.jsx